import { React, useState, useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import CboPeriodos from "./CboPeriodos";
import CboTipoLiq from "./CboTipoLiq";


 let intipoLiq = 0;
 let inperiodoLiq = 0;
const VerLiquid = () => {

   const usenav = useNavigate();

   const [aluid, setAluid] = useState("")  
   const [tipoLiq, setTipoLiq] = useState("")  
   const [periodoLiq, setPeriodoLiq] = useState("") 
   const [noteditable, setNotEditable] = useState(false);
   const [unAlumno, setUnAlumno] = useState([]);
   const [unaLiqDet, setUnaLiqDet] = useState([]); 
  
   const location = useLocation();

useEffect(() => {

    var { unalumno } = location.state || {};

    console.log('Dato alumno a visualizar:', unalumno);
    setAluid(unalumno);
   
}, []) 

const opcMoneda = {
  style: 'currency',
  currency: 'ARS', // Código ISO de la moneda
  minimumFractionDigits: 2, // Mínimo de decimales
  currencyDisplay: 'narrowSymbol' // 'symbol', 'narrowSymbol', 'code', 'name'
};
const formatter = new Intl.NumberFormat('es-ES', opcMoneda);
    

   
    // al cambiar un período o un tipo de liquidación, refrescar la info de la pantalla
function refreshLiq()
{
   console.log("refresh", aluid , intipoLiq , inperiodoLiq);
   // validar que estém todos los campos con datos
   if (aluid && intipoLiq && inperiodoLiq)
   {
        let unLiq = new Object();

        unLiq.alumno = aluid;
        unLiq.tipoliq = Number(intipoLiq);
        unLiq.periodo = Number(inperiodoLiq);
      var url;
      var json2in, json2out;
      // indico el comienzo del procesamiento
      
     
      try { 
 
        json2in = JSON.stringify(unLiq);
        console.log(json2in);

        url = `${process.env.REACT_APP_API_URL}/liq/getone`;
 
  
        var options = {
          method: 'POST',
          headers: {
          'Content-Type': 'application/json'
          },
          mode: 'cors',
          credential : 'include',
          body:  json2in,
          
          };
        
        fetch(url, options)
        .then( response => response.json())
        .then( data => {
          json2out = data.data[0];
           if(json2out[1])
           { 
              
              console.log("finalizar", json2out);
              setUnAlumno(json2out[0][0]);
              setUnaLiqDet(json2out[1]);
              //console.log("la liq", json2out.data[0][0].Alu_IdAlu);
           }
        }).finally ( () => {
           

       })
    } catch (error) {
        console.log(error);
        
    }

  } // del if principal
}

const handleTipoLiqChange = (event) => {
   event.preventDefault()
   console.log("TipoLiq", event.target.value);
    setTipoLiq(event.target.value);
    intipoLiq = event.target.value;
    refreshLiq();
  };  
const handlePeriodoLiqChange = (event) => {
   event.preventDefault()
   console.log("Período", inperiodoLiq);
   console.log("Período evento:", event.target.value);
    setPeriodoLiq(event.target.value);
    inperiodoLiq = event.target.value;
    refreshLiq();
    console.log("Período2", inperiodoLiq);
  };

function formatDate(vfecha)
{
  //return(vfecha);
 
  //console.log('-fecha-' + vfecha + '--')
  if (vfecha == null)
  {
   return ('')
  }
  else
  {
     let vnfecha = vfecha.substr(0,10);
  return(vnfecha.substr(5,2) + '/' + vnfecha.substr(8,2) + '/' + vnfecha.substr(0, 4));
  }
}
    return (
    <>

<div className="container-fluid">

{aluid}

<div className="row" >

     
{/*  Mostrar algunos datos del alumno seleccionado */}   

          <div className="col-lg-offset-0 col-lg-2 col-xs-12 col-sm-6">
            <div className="form-group">
              <label htmlFor="exampleInputEmail1">Tipo Liquidación</label>
            <CboTipoLiq
            selectedValue={tipoLiq} 
            onChange={handleTipoLiqChange} 
            disabled={noteditable}
            />
            </div>
          </div>  
          <div className="col-lg-offset-0 col-lg-2 col-xs-12 col-sm-6">
            <div className="form-group">
              <label htmlFor="exampleInputEmail1">Período de Liquidación</label>
             <CboPeriodos
        selectedValue={periodoLiq} 
        onChange={handlePeriodoLiqChange} 
        disabled={noteditable}
        tipoliq={tipoLiq}
      />
            </div>
          </div>  
    




      </div>

     <table className= {(aluid && tipoLiq && periodoLiq) ? "table table-striped table-primary table-hover m3" : "table table-striped table-primary table-hover m3 d-none" }>

  <thead>

      <tr key={'_tit'}  className="row" >

              <th key={'idalu'} className="col-1">
                { unAlumno.Alu_IdAlu }
              </th> 
              <th key={'nombalu'} className="col-6">
                { unAlumno.Nombre }
              </th>  
              <th key={'importe'} className="col-1">
                { formatter.format(unAlumno.Cte_Total) }
              </th>                            
      </tr> 
    </thead>
<tbody>
{ 


   unaLiqDet.map (( unolista, index ) => (
    <tr key={index+'_row'}  className="row" >

              <td key={index+'_idcon'} className="col-1">
                { unolista.Con_IdCon }
              </td> 
              <td key={index+'_descrip'} className="col-4">
                { unolista.Cde_Descrip }
              </td> 
               <td key={index+'_importe'} className="text-end col-1">
                { formatter.format(unolista.Cde_Importe) }
              </td> 
               <td key={index+'_descuento'} className="text-end col-1">
                { formatter.format(unolista.Cde_Descuento) }
              </td>              
              <td key={index+'_neto'} className="text-end col-1">
                { formatter.format(unolista.Cde_Neto) }
              </td> 

   

    </tr> 
)
)

   }
   </tbody>
</table>
</div>
    </>
    )

}

export default VerLiquid;